import { createSuitMixin as t } from "../mixins/suit.js";
import { createWidgetMixin as e } from "../mixins/widget.js";
import { connectCurrentRefinements as i } from "instantsearch.js/es/connectors/index.js";
import { createPanelConsumerMixin as r } from "../mixins/panel.js";
export default {
  name: "AisCurrentRefinements",
  mixins: [t({
    name: "CurrentRefinements"
  }), e({
    connector: i
  }, {
    $$widgetType: "ais.currentRefinements"
  }), r()],
  props: {
    includedAttributes: {
      type: Array,
      default: void 0
    },
    excludedAttributes: {
      type: Array,
      default: void 0
    },
    transformItems: {
      type: Function,
      default: void 0
    }
  },
  computed: {
    noRefinement: function noRefinement() {
      return this.state && 0 === this.state.items.length;
    },
    widgetParams: function widgetParams() {
      return {
        includedAttributes: this.includedAttributes,
        excludedAttributes: this.excludedAttributes,
        transformItems: this.transformItems
      };
    }
  },
  methods: {
    createItemKey: function createItemKey(t) {
      var e = t.attribute,
          i = t.value;
      return [e, t.type, i, t.operator].join(":");
    },
    capitalize: function capitalize(t) {
      return t ? t.toString().charAt(0).toLocaleUpperCase() + t.toString().slice(1) : "";
    }
  }
};